import { extendMoment } from 'moment-range'

export default ({ $moment }) => {
  extendMoment($moment)
}
